import { forwardRef, Ref, type SVGProps } from 'react';

const SvgPlayIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M.75 2.164c0-.648 0-.972.135-1.15a.67.67 0 0 1 .492-.263c.223-.014.493.166 1.031.525l7.01 4.674c.446.296.668.445.746.632a.67.67 0 0 1 0 .51c-.078.188-.3.336-.745.633l-7.01 4.673c-.54.36-.809.539-1.032.526a.67.67 0 0 1-.492-.264C.75 12.482.75 12.158.75 11.51z"
      transform="matrix(.8633 0 0 .8902 3.333 1.914)"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPlayIcon);
export default ForwardRef;
